var VALIDATION_STATE_MAP = new Map([['default', 'generic'], ['error', 'negative'], ['success', 'positive']]);

export { VALIDATION_STATE_MAP };
//# sourceMappingURL=constants.js.map
